<template>
  <div>
    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-3 col-lg-3">
        <div class="form-group">
          <label for="tipoDoenca">49 - Tipo de doença</label>
          <select
            id="tipoDoenca"
            v-model="guia.consultaReferencia.tipoDoenca"
            data-test-id="select-tipodoenca"
            :disabled="!verificaAcao('faturamento_guia')"
            class="form-control"
          >
            <option disabled value=""> Selecione </option>
            <option
              v-for="tipo in tiposDoencas"
              :key="tipo._id"
              :value="tipo.codigo"
            >
              {{ tipo.valor }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
        <div class="form-group">
          <label for="tempoDoenca"
            >50 - Tempo de doença referida pelo paciente</label
          >
          <div id="tempoDoenca" class="input-group">
            <span class="input-group-addon">Anos</span>
            <input
              id="tempoDoencaAnos"
              v-model="guia.consultaReferencia.tempoDoenca.anos"
              v-mask="'99'"
              data-test-id="input-tempodoencaanos"
              :readonly="!verificaAcao('faturamento_guia')"
              type="number"
              class="form-control"
            />
            <span class="input-group-addon">Meses</span>
            <input
              id="tempoDoencaMeses"
              v-model="guia.consultaReferencia.tempoDoenca.meses"
              v-mask="'99'"
              data-test-id="input-tempodoencameses"
              :readonly="!verificaAcao('faturamento_guia')"
              type="number"
              class="form-control"
            />
            <span class="input-group-addon">Dias</span>
            <input
              id="tempoDoencaDias"
              v-model="guia.consultaReferencia.tempoDoenca.dias"
              v-mask="'99'"
              data-test-id="input-tempodoencadias"
              :readonly="!verificaAcao('faturamento_guia')"
              type="number"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'

import { dominioMixin } from '@/mixins/DominioMixin'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import appStore from '@/stores'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'ConsultaReferencia',
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tiposDoencas: [],
    }
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  created() {
    this.recuperarValoresDominio('TipoDoenca').then((res) => {
      this.tiposDoencas = res.valores
    })
  },
  methods: {
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
  },
}
</script>
